import $ from "jquery";

document.addEventListener( 'DOMContentLoaded', function () {
    console.log("Paying Steps Started");
    $('#pharmacy').on('change', function () {
        var selectedPharmacy = $(this).val();

        if (selectedPharmacy === 'rp') {
            showContent('v1');
        } else if (selectedPharmacy === 'pap') {
            showContent('v2');
        } else if (selectedPharmacy === 'dnk') {
            showContent("other");
        }
        console.log(selectedPharmacy);
    });

    $('#state').on('change', function () {
        showContent("other", $(this).val());
    });

    $('#btn-yes-prescription').on('click', function () {
        var headerHeight = $('header').outerHeight() || 0;
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#pay-99").offset().top - headerHeight
        }, 300);
    });

    function showContent(version, state) {
        switch (version) {
            case "v1":
                $("#content-container").show();

                $('#content-v1').show();
                $('#content-v2').hide();
                $('#state-select').hide();
                break;
            case "v2":
                $("#content-container").show();

                $('#content-v1').hide();
                $('#content-v2').show();
                $('#state-select').hide();
                break;

            case "other":

                $('#state-select').show();
                $("#content-container").toggle(!!state);
                if (state) {
                    $('#content-v1').show();
                    $('#content-v2').hide();
                }
                break;
            default:
                $("#content-container").hide();
                break;
        }
    }
} );